import { InternalApiCustomListMonitoringField, InternalApiCustomListScreeningField } from '../../api-internal';

export type InternalApiUsableField = InternalApiCustomListScreeningField & InternalApiCustomListMonitoringField;

export enum UsableFieldType {
  SCREENING,
  MONITORING,
}
